export default "__VITE_ASSET__BVXqSzai__"